import { Component } from "@angular/core";
import { CommonModule } from "@angular/common";
import { Router } from "@angular/router";

@Component({
  selector: "app-privacy-policy",
  imports: [CommonModule],
  templateUrl: "./privacy-policy.component.html",
  styleUrl: "./privacy-policy.component.css",
})
export class PrivacyPolicyComponent {
  constructor(private router: Router) {
    this.lastUpdated = new Date().toLocaleDateString();
  }
  
  lastUpdated: string;

  goBack(): void {
    this.router.navigate([""]);
  }
}
